import {
    isObjectEmpty,
    isString,
    MemberField,
    MemberFieldValueType,
    size,
    trim
} from '@libs/shared';
import { IRuleDescriptor } from '@fx-ui/fine-design';
import Intl from '@fx-ui/intl';

/**
 * 校验成员预设字段值
 * @param field
 * @param value
 */
export const validateMemberFieldValue = (field: MemberField, value: any): [boolean, string] => {
    const trimValue = isString(value) ? trim(value) : value;
    if (field.required && isObjectEmpty(trimValue)) {
        return [false, ''];
    }
    if (
        field.valueType === MemberFieldValueType.Text &&
        field.maxWordCount &&
        size(trimValue) > field.maxWordCount
    ) {
        return [false, Intl.get('fxp.max_chars.tip', { limit: field.maxWordCount })];
    }
    return [true, ''];
};

/**
 * 获取成员预设字段值校验规则
 * @param field
 */
export const getMemberFieldRule = (field: MemberField): IRuleDescriptor | undefined => {
    if (field.valueType === MemberFieldValueType.Text) {
        return {
            type: 'string',
            validate: (value: string) => {
                return validateMemberFieldValue(field, value)[0];
            },
            message: ''
        };
    }
    return undefined;
};
